import en from '@root/public/static/en.svg';
import es from '@root/public/static/es.svg';
import ru from '@root/public/static/ru.svg';
import pl from '@root/public/static/pl.svg';
import de from '@root/public/static/de.svg';
import fr from '@root/public/static/fr.svg';
import it from '@root/public/static/it.svg';
import pt from '@root/public/static/pt.svg';
import nl from '@root/public/static/nl.svg';

const languageOptions = {
  de: {
    value: 'de',
    label: {
      image: de,
      text: 'Deutsch',
    },
  },
  fr: {
    value: 'fr',
    label: {
      image: fr,
      text: 'Français',
    },
  },
  en: {
    value: 'en',
    label: {
      image: en,
      text: 'English',
    },
  },
  es: {
    value: 'es',
    label: {
      image: es,
      text: 'Español',
    },
  },
  nl: {
    value: 'nl',
    label: {
      image: nl,
      text: 'Nederlands',
    },
  },
  pl: {
    value: 'pl',
    label: {
      image: pl,
      text: 'Polski',
    },
  },
  ru: {
    value: 'ru',
    label: {
      image: ru,
      text: 'Pусский',
    },
  },
  it: {
    value: 'it',
    label: {
      image: it,
      text: 'Italiano',
    },
  },
  pt: {
    value: 'pt',
    label: {
      image: pt,
      text: 'Português',
    },
  },
};

export default languageOptions;
